import React from 'react';

import { useFeatureFlags } from 'Utilities/hooks';
import { useReturningUser } from 'Utilities/hooks/useReturningUser';

import { BreakpointProvider } from '../../../../../components/misc/Breakpoints/Breakpoints';
import { CarPrizeJan2026 } from '../../Components/CarPrizeJan2026/CarPrizeJan2026';
import { FullBleedImage } from '../../Components/FullBleedImage/FullBleedImage';
import { GuidesSection as Guides } from '../../Components/GuidesSection/GuidesSection';
import { Hero as HomepageHero } from '../../Components/Hero/Hero';
import { HeroReturningUser } from '../../Components/Hero/HeroReturningUser';
import { HomepageFAQ } from '../../Components/HomepageFAQ/HomepageFAQ';
import { HomepagePartnerLogos } from '../../Components/HomepagePartnerLogos/HomepagePartnerLogos';
import { HowItWorks } from '../../Components/HowItWorks/HowItWorks';
import { NewsAndTools } from '../../Components/NewsAndTools/NewsAndTools';
import { Reviews } from '../../Components/Reviews/Reviews';
import { SellerStories } from '../../Components/SellerStories/SellerStories';
import { SocialProof } from '../../Components/SocialProof/SocialProof';

import { LogReturningUser } from './LogReturningUser';

import styles from './Homepage.scss';

const HomepageHeroContent = () => (
  useReturningUser() ? <HeroReturningUser /> : <HomepageHero />
);

const Homepage = () => {
  const { showCarPrizeJan2026 } = useFeatureFlags();

  return (
    <>
      <LogReturningUser />
      <BreakpointProvider>
        <HomepageHeroContent />
        {showCarPrizeJan2026 ? <CarPrizeJan2026 /> : null}
        <HowItWorks className={styles.howItWorks} />
        <SellerStories className={styles.sellerStories} />
        <FullBleedImage />
        <SocialProof />
        <Reviews className={styles.reviews} />
        <HomepagePartnerLogos className={styles.partnerLogos} />
        <NewsAndTools className={styles.newsAndTools} />
        <HomepageFAQ className={styles.faq} />
        <Guides />
      </BreakpointProvider>
    </>
  );
};

export default Homepage;
